import React, { useCallback, useEffect, useState } from "react";
import {
  Autocomplete,
  EraserIcon,
  FormField,
  IconButton,
  InlineAlert,
  Pane,
  TextInput,
} from "evergreen-ui";
import VendorFormDialogButton from "./VendorFormDialogButton";
import useControlHub from "../../hooks/useControlHub";

const AutocompleteTextInput = ({
  getInputProps,
  getRef,
  inputValue,
  openMenu,
}) => {
  return (
    <TextInput
      placeholder="Select a vendor"
      value={inputValue}
      ref={getRef}
      {...getInputProps({ onFocus: () => openMenu() })}
    />
  );
};

const VendorInputFixed = ({ vendor }) => {
  return <TextInput disabled value={vendor.name} />;
};

const VendorInput = ({ onDataChange, vendor }) => {
  const { api } = useControlHub();
  const [vendors, setVendors] = useState();

  useEffect(() => {
    if (!vendors) {
      api
        .getVendors({ preferred: true })
        .then((data) => {
          if (!data) {
            throw new Error("Couldn't fetch vendors list");
          }
          setVendors(data);
        })
        .catch(() => {
          setVendors();
        });
    }
  }, [api, vendors]);

  const vendorToString = (vendor) => (vendor ? vendor.name : "");

  const handleNewVendorCreated = useCallback(
    (vendor) => {
      if (vendor) {
        setVendors();
        onDataChange({ vendor: vendor.id });
      }
    },
    [onDataChange]
  );

  const handleEdit = useCallback(() => {
    onDataChange({ vendor: "" });
  }, [onDataChange]);

  const handleSelectChange = useCallback(
    (vendor) => {
      onDataChange({ vendor: vendor ? vendor.id : "" });
    },
    [onDataChange]
  );

  const VendorInputEdit = () => (
    <Autocomplete
      id="vendor"
      items={vendors}
      itemToString={vendorToString}
      onChange={handleSelectChange}
      title="Vendors"
    >
      {AutocompleteTextInput}
    </Autocomplete>
  );

  return (
    <Pane display="flex" flexWrap="wrap">
      <FormField flex="1 1 auto" label="Vendor Name" labelFor="vendor">
        {vendors && !vendor ? (
          <VendorInputEdit />
        ) : (
          <Pane display="flex">
            {vendors ? (
              <>
                <VendorInputFixed
                  vendor={
                    vendors.find((current) => current.id === vendor) || {
                      name: vendor,
                    }
                  }
                />
                <IconButton
                  appearance="minimal"
                  aria-label="Clear Vendor Selection"
                  icon={EraserIcon}
                  onClick={handleEdit}
                />
              </>
            ) : (
              <InlineAlert intent="warning">
                {"Couldn't retrieve vendors list"}
              </InlineAlert>
            )}
          </Pane>
        )}
      </FormField>
      <Pane display="flex" flex="1 1 auto" justifyContent="flex-end">
        <VendorFormDialogButton
          onSuccess={handleNewVendorCreated}
          vendorID={vendor}
        />
      </Pane>
    </Pane>
  );
};

export default VendorInput;
